import { FC, useEffect } from "react";
import {useNavigate} from "react-router-dom";

interface Props {
    roles: string[],
    requiredRole: string
}

const ProtectedRoute: FC<Props> = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        if(!props.roles.includes(props.requiredRole)) navigate('/not-found')
    },[props.requiredRole, props.roles])
    return (
        <>
            {props.children}
        </>
    );
};

export default ProtectedRoute;